<template>
  <VideoListPageContent
    :sort-type="NavigationSortType.All"
    :category="category"
    :category-sorts="sorts"
  />
</template>

<script setup lang="ts">
import { useNavigation } from '~/stores/navigation'
import { NavigationSortType } from '~/models/navigation'

const route = useRoute()
const { categoriesSlugMap, getCategorySortItems } = useNavigation()

const category = categoriesSlugMap[route.params.category as string]

if (!category) {
  throw useCreateScreenError({
    message: `category ${category} is not found on video category index`,
  })
}

const sorts = getCategorySortItems('video', category.slug, [
  NavigationSortType.Popular,
  NavigationSortType.All,
])
</script>
